import React, { useState } from 'react';
import { LazyDialog, lazyDialog } from '../enquiry/lazyDialog';

// The dialog (the Radix shell and the full-size art) is its own chunk, fetched on the first
// open or when the trigger is hovered or focused.
const designDialog = lazyDialog(() => import(/* webpackChunkName: "coaster-design" */ './CoasterDesignBody'));

/** Start loading the design dialog now. */
export const preloadCoasterDesign = () => designDialog.preload();

const LOAD_ERROR = "The design couldn't open just now. Check your connection and try again.";

/**
 * "View the design": a text button under a tier's coaster photo that opens the flat example
 * artwork for that tier at full size (Venue Sponsor: front and back together). Focus returns
 * to the button on close.
 *
 * Props: `tier` ('standard' | 'premium' | 'sponsor'), `tierName` (display name), `spaces`
 * (Standard: logo spaces per venue, from the live tiers), `className`.
 */
export default function CoasterDesign({ tier, tierName, spaces, className }) {
  const [open, setOpen] = useState(false);
  const buttonRef = React.useRef(null);
  const close = () => {
    setOpen(false);
    const el = buttonRef.current;
    if (el && el.isConnected && typeof el.focus === 'function') el.focus();
  };
  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        aria-haspopup="dialog"
        onClick={() => setOpen(true)}
        onPointerEnter={preloadCoasterDesign}
        onFocus={preloadCoasterDesign}
        data-testid="coaster-design-button"
        className={className}
      >
        View the design<span className="sr-only">: {tierName} example coaster</span>
      </button>
      <LazyDialog
        dialog={designDialog}
        open={open}
        onClose={close}
        errorMessage={LOAD_ERROR}
        render={(Body) => (
          <Body open={open} onOpenChange={setOpen} tier={tier} tierName={tierName} spaces={spaces} returnFocusRef={buttonRef} />
        )}
      />
    </>
  );
}
